import { QueryResponseCache, Network } from 'relay-runtime';
import { createEnvironment, createFetchQuery } from 'finish-line';

import config from '../config';

import { auth } from './authService';

export const createRelayEnvironment = () => {
  const cache = new QueryResponseCache({ size: 250, ttl: 5 * 60 * 1000 });
  return createEnvironment({
    cache,
    headers: auth.getHeaders,
    path: `${config.API_URL}/graphql`,
  });
};

export const createFetchQueryEnvironment = () => {
  const cache = new QueryResponseCache({ size: 250, ttl: 5 * 60 * 1000 });
  return createFetchQuery({
    cache,
    headers: auth.getHeaders,
    path: `${config.API_URL}/graphql`,
  });
};

export const network = Network.create(createFetchQueryEnvironment);
